/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiAIChunkFromJSON(json) {
    return ApiAIChunkFromJSONTyped(json, false);
}
export function ApiAIChunkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'err': !exists(json, 'err') ? undefined : json['err'],
        'logId': !exists(json, 'logId') ? undefined : json['logId'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}
export function ApiAIChunkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'err': value.err,
        'logId': value.logId,
        'text': value.text,
    };
}
